import { ReadonlyInput } from 'components/common/ReadonlyInput';
import { LoadingIndicator } from 'components/common/LoadingIndicator';
import usePushManagementCompare from 'lib/hooks/usePushManagementCompare';
import {
  getLabelByValueFromOptions,
  PushActionHappyTabsOptions,
  PushActionTabularyTabsOptions,
  PushCardOptions,
  PushTabOptions,
} from '../constants';

export const TabCompare = () => {
  const { pushConfig, isLoading } = usePushManagementCompare();

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return (
    <div className="p-4">
      {pushConfig.length === 0 && (
        <p className="text-md text-center">No changes</p>
      )}
      <div className="flex">
        <div className="flex-grow">
          {pushConfig.map(({ type, days, ...config }, index) => {
            return (
              <div className="pb-4 mb-4 border-b border-gray-200" key={index}>
                <p className="text-lg mb-4">{type}</p>
                <div className="grid grid-cols-11 gap-2">
                  <div className="col-span-2">
                    <ReadonlyInput
                      label="Push title"
                      value={config.dayTitle}
                      labelStyle="block text-sm text-gray-400 mb-2"
                      inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                      controlStyle="bg-blue-30 mb-4 w-full relative"
                    />
                    {config.draft.dayTitle && (
                      <ReadonlyInput
                        label=""
                        value={config.draft.dayTitle}
                        labelStyle="block text-sm text-gray-400 mb-2"
                        inputStyle="w-full rounded py-2 px-4 block border-gray-200 border-2 bg-green-100"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                      />
                    )}
                  </div>
                  <div className="col-span-2">
                    <ReadonlyInput
                      label="Push message"
                      value={config.dayMessage}
                      labelStyle="block text-sm text-gray-400 mb-2"
                      inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                      controlStyle="bg-blue-30 mb-4 w-full relative"
                    />
                    {config.draft.dayMessage && (
                      <ReadonlyInput
                        label=""
                        value={config.draft.dayMessage}
                        labelStyle="block text-sm text-gray-400 mb-2"
                        inputStyle="w-full rounded py-2 px-4 block border-gray-200 border-2 bg-green-100"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                      />
                    )}
                  </div>
                  <div className="">
                    <ReadonlyInput
                      label="Push time"
                      value={config.deliveryTime}
                      labelStyle="block text-sm text-gray-400 mb-2"
                      inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                      controlStyle="bg-blue-30 mb-4 w-full relative"
                    />
                    {!config.draft.specificDay && config.draft.deliveryTime && (
                      <ReadonlyInput
                        label=""
                        value={config.draft.deliveryTime}
                        labelStyle="block text-sm text-gray-400 mb-2"
                        inputStyle="w-full rounded py-2 px-4 block border-gray-200 border-2 bg-green-100"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                      />
                    )}
                  </div>
                  <div className="">
                    <ReadonlyInput
                      label="Day Specific"
                      value={config.specificDay ? 'Yes' : 'No'}
                      labelStyle="block text-sm text-gray-400 mb-2"
                      inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                      controlStyle="bg-blue-30 mb-4 w-full relative"
                    />
                    {typeof config.draft.specificDay === 'boolean' && (
                      <ReadonlyInput
                        label=""
                        value={config.draft.specificDay ? 'Yes' : 'No'}
                        labelStyle="block text-sm text-gray-400 mb-2"
                        inputStyle="w-full rounded py-2 px-4 block border-gray-200 border-2 bg-green-100"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                      />
                    )}
                  </div>
                  <div className="">
                    <ReadonlyInput
                      label="Active"
                      value={config.active ? 'Yes' : 'No'}
                      labelStyle="block text-sm text-gray-400 mb-2"
                      inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                      controlStyle="bg-blue-30 mb-4 w-full relative"
                    />
                    {!config.draft.specificDay &&
                      typeof config.draft.active === 'boolean' && (
                        <ReadonlyInput
                          label=""
                          value={config.draft.active ? 'Yes' : 'No'}
                          labelStyle="block text-sm text-gray-400 mb-2"
                          inputStyle="w-full rounded py-2 px-4 block border-gray-200 border-2 bg-green-100"
                          controlStyle="bg-blue-30 mb-4 w-full relative"
                        />
                      )}
                  </div>
                  <div className="">
                    <ReadonlyInput
                      label="Tab"
                      value={getLabelByValueFromOptions(
                        config.tabType,
                        PushTabOptions,
                      )}
                      labelStyle="block text-sm text-gray-400 mb-2"
                      inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                      controlStyle="bg-blue-30 mb-4 w-full relative"
                    />
                    {config.draft.tabType && (
                      <ReadonlyInput
                        label=""
                        value={getLabelByValueFromOptions(
                          config.draft.tabType,
                          PushTabOptions,
                        )}
                        labelStyle="block text-sm text-gray-400 mb-2"
                        inputStyle="w-full rounded py-2 px-4 block border-gray-200 border-2 bg-green-100"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                      />
                    )}
                  </div>
                  <div className="">
                    <div className="h-20">
                      {config.tabType === 'happy_tabs' && (
                        <ReadonlyInput
                          label="Action"
                          value={getLabelByValueFromOptions(
                            config.actionHappyTabsType,
                            PushActionHappyTabsOptions,
                          )}
                          labelStyle="block text-sm text-gray-400 mb-2"
                          inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                          controlStyle="bg-blue-30 mb-4 w-full relative"
                        />
                      )}
                      {config.tabType === 'tabulary' && (
                        <ReadonlyInput
                          label="Action"
                          value={getLabelByValueFromOptions(
                            config.actionTabularyTabsType,
                            PushActionTabularyTabsOptions,
                          )}
                          labelStyle="block text-sm text-gray-400 mb-2"
                          inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                          controlStyle="bg-blue-30 mb-4 w-full relative"
                        />
                      )}
                    </div>

                    {config.draft.tabType === 'happy_tabs' && (
                      <ReadonlyInput
                        label=""
                        value={getLabelByValueFromOptions(
                          config.draft.actionHappyTabsType,
                          PushActionHappyTabsOptions,
                        )}
                        labelStyle="block text-sm text-gray-400 mb-2"
                        inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2 bg-green-100"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                      />
                    )}
                    {config.draft.tabType === 'tabulary' && (
                      <ReadonlyInput
                        label=""
                        value={getLabelByValueFromOptions(
                          config.draft.actionTabularyTabsType,
                          PushActionTabularyTabsOptions,
                        )}
                        labelStyle="block text-sm text-gray-400 mb-2"
                        inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2 bg-green-100"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                      />
                    )}
                  </div>
                  <div className="">
                    <div className="h-20">
                      {config.tabType === 'happy_tabs' && (
                        <ReadonlyInput
                          label="Card"
                          value={getLabelByValueFromOptions(
                            config.cardType,
                            PushCardOptions,
                          )}
                          labelStyle="block text-sm text-gray-400 mb-2"
                          inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                          controlStyle="bg-blue-30 mb-4 w-full relative"
                        />
                      )}
                    </div>
                    {config.draft.tabType === 'happy_tabs' && (
                      <ReadonlyInput
                        label=""
                        value={getLabelByValueFromOptions(
                          config.draft.cardType,
                          PushCardOptions,
                        )}
                        labelStyle="block text-sm text-gray-400 mb-2"
                        inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2 bg-green-100"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                      />
                    )}
                  </div>
                  <div className="">
                    <div className="h-20">
                      {config.tabType === 'happy_tabs' &&
                        config.actionHappyTabsType &&
                        config.actionHappyTabsType !== 'compose' && (
                          <ReadonlyInput
                            label="Unflip"
                            value={config.unflipAllTabs ? 'Yes' : 'No'}
                            labelStyle="block text-sm text-gray-400 mb-2"
                            inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                            controlStyle="bg-blue-30 mb-4 w-full relative"
                          />
                        )}
                    </div>
                    {typeof config.draft.unflipAllTabs === 'boolean' && (
                      <ReadonlyInput
                        label=""
                        value={config.draft.unflipAllTabs ? 'Yes' : 'No'}
                        labelStyle="block text-sm text-gray-400 mb-2"
                        inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2 bg-green-100"
                        controlStyle="bg-blue-30 mb-4 w-full relative"
                      />
                    )}
                  </div>
                </div>
                <div>
                  {days?.map((day) => (
                    <div className="grid grid-cols-11 gap-2" key={day.id}>
                      <div className="col-span-2">
                        <ReadonlyInput
                          label={`${day.day?.toUpperCase()} Push title`}
                          value={day.specificDayTitle}
                          labelStyle="block text-sm text-gray-400 mb-2"
                          inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                          controlStyle="bg-blue-30 mb-4 w-full relative"
                        />
                        {day.draft?.specificDayTitle && (
                          <ReadonlyInput
                            label=""
                            value={day.draft?.specificDayTitle}
                            labelStyle="block text-sm text-gray-400 mb-2"
                            inputStyle="w-full rounded py-2 px-4 block border-gray-200 border-2 bg-green-100"
                            controlStyle="bg-blue-30 mb-4 w-full relative"
                          />
                        )}
                      </div>
                      <div className="col-span-2">
                        <ReadonlyInput
                          label={`${day.day?.toUpperCase()} Push message`}
                          value={day.specificDayMessage}
                          labelStyle="block text-sm text-gray-400 mb-2"
                          inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                          controlStyle="bg-blue-30 mb-4 w-full relative"
                        />
                        {day.draft?.specificDayMessage && (
                          <ReadonlyInput
                            label=""
                            value={day.draft?.specificDayMessage}
                            labelStyle="block text-sm text-gray-400 mb-2"
                            inputStyle="w-full rounded py-2 px-4 block border-gray-200 border-2 bg-green-100"
                            controlStyle="bg-blue-30 mb-4 w-full relative"
                          />
                        )}
                      </div>
                      <div className="">
                        <ReadonlyInput
                          label="Push time"
                          value={day.deliveryTime}
                          labelStyle="block text-sm text-gray-400 mb-2"
                          inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                          controlStyle="bg-blue-30 mb-4 w-full relative"
                        />
                        {day.draft?.deliveryTime && (
                          <ReadonlyInput
                            label=""
                            value={day.draft.deliveryTime}
                            labelStyle="block text-sm text-gray-400 mb-2"
                            inputStyle="w-full rounded py-2 px-4 block border-gray-200 border-2 bg-green-100"
                            controlStyle="bg-blue-30 mb-4 w-full relative"
                          />
                        )}
                      </div>
                      <div className="" />
                      <div className="">
                        <ReadonlyInput
                          value={day.active ? 'Yes' : 'No'}
                          label="Active"
                          labelStyle="block text-sm text-gray-400 mb-2"
                          inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                          controlStyle="bg-blue-30 mb-4 w-full relative"
                        />
                        {typeof day.draft?.active === 'boolean' && (
                          <ReadonlyInput
                            value={day.draft?.active ? 'Yes' : 'No'}
                            label=""
                            labelStyle="block text-sm text-gray-400 mb-2"
                            inputStyle="w-full rounded py-2 px-4 block border-gray-200 border-2 bg-green-100"
                            controlStyle="bg-blue-30 mb-4 w-full relative"
                          />
                        )}
                      </div>
                      <div className="">
                        <ReadonlyInput
                          label="Tab"
                          value={getLabelByValueFromOptions(
                            day.tabType,
                            PushTabOptions,
                          )}
                          labelStyle="block text-sm text-gray-400 mb-2"
                          inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                          controlStyle="bg-blue-30 mb-4 w-full relative"
                        />
                        {day.draft?.tabType && (
                          <ReadonlyInput
                            label=""
                            value={getLabelByValueFromOptions(
                              day.draft.tabType,
                              PushTabOptions,
                            )}
                            labelStyle="block text-sm text-gray-400 mb-2"
                            inputStyle="w-full rounded py-2 px-4 block border-gray-200 border-2 bg-green-100"
                            controlStyle="bg-blue-30 mb-4 w-full relative"
                          />
                        )}
                      </div>
                      <div className="">
                        <div className="h-20">
                          {day.tabType === 'happy_tabs' && (
                            <ReadonlyInput
                              label="Action"
                              value={getLabelByValueFromOptions(
                                day.actionHappyTabsType,
                                PushActionHappyTabsOptions,
                              )}
                              labelStyle="block text-sm text-gray-400 mb-2"
                              inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                              controlStyle="bg-blue-30 mb-4 w-full relative"
                            />
                          )}
                          {day.tabType === 'tabulary' && (
                            <ReadonlyInput
                              label="Action"
                              value={getLabelByValueFromOptions(
                                day.actionTabularyTabsType,
                                PushActionTabularyTabsOptions,
                              )}
                              labelStyle="block text-sm text-gray-400 mb-2"
                              inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                              controlStyle="bg-blue-30 mb-4 w-full relative"
                            />
                          )}
                        </div>

                        {day.draft?.actionHappyTabsType && (
                          <ReadonlyInput
                            label=""
                            value={getLabelByValueFromOptions(
                              day.draft.actionHappyTabsType,
                              PushActionHappyTabsOptions,
                            )}
                            labelStyle="block text-sm text-gray-400 mb-2"
                            inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2 bg-green-100"
                            controlStyle="bg-blue-30 mb-4 w-full relative"
                          />
                        )}
                        {day.draft?.actionTabularyTabsType && (
                          <ReadonlyInput
                            label=""
                            value={getLabelByValueFromOptions(
                              day.draft.actionTabularyTabsType,
                              PushActionTabularyTabsOptions,
                            )}
                            labelStyle="block text-sm text-gray-400 mb-2"
                            inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2 bg-green-100"
                            controlStyle="bg-blue-30 mb-4 w-full relative"
                          />
                        )}
                      </div>
                      <div className="">
                        <div className="h-20">
                          {day.tabType === 'happy_tabs' && (
                            <ReadonlyInput
                              label="Card"
                              value={getLabelByValueFromOptions(
                                day.cardType,
                                PushCardOptions,
                              )}
                              labelStyle="block text-sm text-gray-400 mb-2"
                              inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                              controlStyle="bg-blue-30 mb-4 w-full relative"
                            />
                          )}
                        </div>
                        {day.draft?.cardType && (
                          <ReadonlyInput
                            label=""
                            value={getLabelByValueFromOptions(
                              day.draft.cardType,
                              PushCardOptions,
                            )}
                            labelStyle="block text-sm text-gray-400 mb-2"
                            inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2 bg-green-100"
                            controlStyle="bg-blue-30 mb-4 w-full relative"
                          />
                        )}
                      </div>
                      <div className="">
                        <div className="h-20">
                          {day.tabType === 'happy_tabs' &&
                            day.actionHappyTabsType &&
                            day.actionHappyTabsType !== 'compose' && (
                              <ReadonlyInput
                                label="Unflip"
                                value={day.unflipAllTabs ? 'Yes' : 'No'}
                                labelStyle="block text-sm text-gray-400 mb-2"
                                inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2"
                                controlStyle="bg-blue-30 mb-4 w-full relative"
                              />
                            )}
                        </div>
                        {typeof day.draft?.unflipAllTabs === 'boolean' && (
                          <ReadonlyInput
                            label=""
                            value={day.draft.unflipAllTabs ? 'Yes' : 'No'}
                            labelStyle="block text-sm text-gray-400 mb-2"
                            inputStyle="w-full rounded mt-2 py-2 px-4 block border-gray-200 border-2 bg-green-100"
                            controlStyle="bg-blue-30 mb-4 w-full relative"
                          />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
        <div className="flex flex-col justify-end w-32 relative" />
      </div>
    </div>
  );
};
